import { httpService } from '../providers/http-service'
import cnpjValidator from '../validators/cnpj-validator'

const RECEITA_WS_TIMEOUT = 10000

export const helper = {
  data () {
    return { callingReceitaWs: false }
  },
  filters: {
    cnaeFilter (val) {
      return val.substring(0, 4) + '-' + val.substring(4, 5) + '/' + val.substring(5, 7)
    },
    textUpper (val) {
      return val.toUpperCase()
    },
    cnpj (val) {
      return val.substring(0, 2) + '.' + val.substring(2, 5) + '.' + val.substring(5, 8) +
      '/' + val.substring(8, 12) + '-' + val.substring(12, 14)
    },
    cpf (val) {
      return val.substring(0, 3) + '.' + val.substring(3, 6) + '.' + val.substring(6, 9) +
      '-' + val.substring(9, 11)
    },
    cep (val) {
      if (val) {
        return val.substring(0, 2) + '.' + val.substring(2, 5) + '-' + val.substring(5, 8)
      }
    },
    phone (val) {
      if (val && val.length === 10) {
        return '(' + val.substring(0, 2) + ') ' + val.substring(2, 6) + '-' + val.substring(6, 10)
      } else if (val && val.length === 11) {
        return '(' + val.substring(0, 2) + ') ' + val.substring(2, 7) + '-' + val.substring(7, 11)
      } else {
        return val
      }
    }
  },
  methods: {
    resetForm () {
      this.company = { status: '1', type: '0', state: 'UF', activities: [], tags: [] }
      this.emails = []
      this.$validator.reset()
    },

    dataHandler (dt) {
      return new Promise((resolve, reject) => {
        if (dt.document) { dt.document = dt.document.replace(/[&\/\#,+()$~%.'":*?<>{}-\s]/g, '') }
        if (dt.cep) { dt.cep = dt.cep.replace(/[&\/\#,+()$~%.'":*?<>{}-\s]/g, '') }
        if (dt.ie) { dt.ie = dt.ie.replace(/[&\/\#,+()$~%.'":*?<>{}-\s]/g, '') }
        if (dt.im) { dt.im = dt.im.replace(/[&\/\#,+()$~%.'":*?<>{}-\s]/g, '') }

        if (dt.type === '1') {
          dt.fantasy = ''
          dt.contact = ''
          dt.contact_phone = ''
          dt.ie = ''
          dt.im = ''
        }

        dt.state.toUpperCase()
        dt.type = parseInt(dt.type)
        dt.status = parseInt(dt.status)

        // função para tratar a repetição e envio do cnae para o server.
        delete dt.cnae
        if (dt.activities) {
          let activities = []
          dt.activities.forEach((item, idx) => {
            if (idx === 0) {
              activities.push({ code: item.code, main: true })
            } else { activities.push({ code: item.code, main: false }) }
          })
          dt.activities = activities
        }
        resolve(dt)
      })
    },

    populateFields (dt) {
      this.company.id = dt.public_key
      this.company.status = dt.status
      this.company.type = dt.type
      this.company.document = dt.document
      this.company.name = dt.name
      this.company.fantasy = dt.fantasy
      this.company.phone = dt.phone
      this.company.ie = dt.ie
      this.company.im = dt.im
      this.company.contact = dt.contact
      this.company.contact_phone = dt.contact_phone
      this.company.tags = dt.tags
      this.emails = dt.email ? dt.email.split(',') : []

      // address
      this.company.cep = dt.cep
      this.company.place = dt.place
      this.company.number = dt.number
      this.company.neighborhood = dt.neighborhood
      this.company.city = dt.city
      this.company.state = dt.state
      this.company.complement = dt.complement ? dt.complement.substr(0, 255) : ''

      if (dt.activities && typeof dt.activities == 'string') {
        this.company.activities = JSON.parse(dt.activities)
      } else {
        this.company.activities = dt.activities
      }
    },

    maskPhone (ev, model) {
      let num = ev.target.value.replace(/\D/g, '').substring(0, 11)

      if (num.length === 0) {
        num += num
      } else if (num.length < 3) {
        num = '(' + num
      } else if (num.length < 6) {
        num = '(' + num.substring(0, 2) + ') ' + num.substring(2, 5)
      } else if (num.length < 10) {
        num = '(' + num.substring(0, 2) + ') ' + num.substring(2, 6) + '-' + num.substring(6, 9)
      } else if (num.length === 10) {
        num = '(' + num.substring(0, 2) + ') ' + num.substring(2, 6) + '-' + num.substring(6, 10)
      } else if (num.length === 11) {
        num = '(' + num.substring(0, 2) + ') ' + num.substring(2, 7) + '-' + num.substring(7, 11)
      } else {
        num = '(' + num.substring(0, 2) + ') ' + num.substring(2, 7) + '-' + num.substring(7, 11)
      }

      if (model === 'phone') {
        this.company.phone = num
      } else {
        this.company.contact_phone = num
      }
    },

    getCompanyData (cnpj) {
      this.company.name = ''
      this.company.fantasy = ''
      this.company.phone = ''
      this.company.number = ''
      this.company.complement = ''
      this.company.activities = []

      if (!cnpj) { return }

      cnpj = cnpj.replace(/[&\/\#,+()$~%.'":*?<>{}-\s]/g, '')
      if (cnpjValidator.validate(cnpj) && !this.callingReceitaWs) {
        this.showSpinner = true
        this.callingReceitaWs = true

        httpService.consultCNPJ(cnpj, RECEITA_WS_TIMEOUT).then((res) => {
          if (res.data.status === 'ERROR') {
            this.show_toast('error', 'Erro!', res.data.message)
            this.showSpinner = false
          } else {
            this.company.name = res.data.nome
            this.company.fantasy = res.data.fantasia
            this.company.emails = res.data.email ? [res.data.email] : undefined
            this.company.phone = res.data.telefone

            if (res.data.atividade_principal) {
              res.data.atividade_principal.forEach((atividade) => {
                let cd = atividade.code.replace(/[&\/\#,+()$~%.'":*?<>{}-\s]/g, '')
                this.company.activities.push({ code: cd, description: atividade.text })
              })
            }

            if (res.data.atividades_secundarias) {
              res.data.atividades_secundarias.forEach((secundaria) => {
                let cd = secundaria.code.replace(/[&\/\#,+()$~%.'":*?<>{}-\s]/g, '')
                if (cd !== '0000000' || secundaria.text !== 'Não informada') {
                  this.company.activities.push({ code: cd, description: secundaria.text })
                }
              })
            }

            if (res.data.cep) {
              this.company.cep = res.data.cep.replace(/[&\\#,+()$~%.'":*?<>{}-\s]/g, '')
              this.getAddress(this.company.cep)
            } else {
              this.showSpinner = false
              this.show_toast('warning', 'CEP não encontrado', 'Não encontramos nenhum CEP associado ao CNPJ.', 8000)
            }

            this.company.number = res.data.numero
            this.company.complement = res.data.complemento

            this.company.cnae = {}
            this.company.cnae.code = res.data.atividade_principal[0].code.replace(/[.\-\/]/g, '')
            this.company.cnae.description = res.data.atividade_principal[0].text
          }
        }).catch((err) => {
          if (err.response) { // Resposta do Receita WS
            switch (err.response.status) {
              case 429:
                this.show_toast('warning', 'Limite de consultas atingido', 'Não foi possível consultar o CNPJ agora. Por favor, aguarde um minuto e tente novamente.', 10000)
                break
              default:
                this.show_toast('error', 'Falha ao consultar CNPJ', 'Por favor, Tente novamente mais tarde.', 8000)
            }
          } else { // Timeout: Receita WS não respondeu a tempo
            this.show_toast('warning', 'CNPJ não encontrado', 'CNPJ inexistente ou não pré-cadastrado. Por favor, verifique se você digitou o CNPJ corretamente.', 10000)
          }
          this.showSpinner = false
        }).finally(() => {
          this.callingReceitaWs = false
        })
      }
    },

    getAddress (cep) {

      if (!cep) { return }

      this.company.place = ''
      this.company.neighborhood = ''
      this.company.city = ''
      this.company.state = 'UF'
      this.$validator.reset({'UF': this.company.state})


      cep = cep.split('.').join('').replace(/[^\w ]/, '').replace(/^s+|s+$/g, '')
      var objER = /^[0-9]{8}$/

      if (cep.length > 0 && objER.test(cep)) {
        this.showSpinner = true
        httpService.consultCEP(cep)
          .then((data) => {
            let dt = data.data
            if (parseInt(dt.resultado) === 1) {
              this.company.place = dt.tipo_logradouro + ' ' + dt.logradouro
              this.company.neighborhood = dt.bairro || ''
              this.company.city = dt.cidade || ''
              this.company.state = dt.uf || ''
              this.showSpinner = false
            } else {
              this.showSpinner = false
              this.show_toast('warning', 'Endereço não encontrado', `Nenhum endereço encontrado para o CEP ${this.$options.filters.cep(cep)}.`, 8000)
            }
          }, error => {
            this.showSpinner = false
            this.show_toast('error', 'Ops', `Não foi possível realizar a ação ${error}.`)
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/helper.js